


































import {
  Component,
  Vue,
} from 'vue-property-decorator';

import bForm from 'bootstrap-vue/es/components/form/form';
import bFormSelect from 'bootstrap-vue/es/components/form-select/form-select';

import BuyboxFeatureComponent from './BuyboxFeatureComponent';

@Component({
  components: {
    bForm,
    bFormSelect,
  },
  props: {
    // Allow two-way binding with v-model.
    value: {
      type: Number,
      required: true,
    },
  },
})
export default class QuantityFeature extends BuyboxFeatureComponent {
  private static readonly MaxOrderQuantity = 20;

  get maxQuantity() {
    const inventory = this.variant.inventory;
    if (!inventory) {
      return QuantityFeature.MaxOrderQuantity;
    } else {
      return (inventory.quantity > QuantityFeature.MaxOrderQuantity) ?
        QuantityFeature.MaxOrderQuantity : inventory.quantity;
    }
  }
}

